import React, { FC } from 'react'
import styles from './index.module.less'

interface ResultHeaderProps {
	title: string
}

const ResultHeader: FC<ResultHeaderProps> = ({ title }) => {
	return <span className={styles.divider}>{title}</span>
}

export default ResultHeader
